import { useState } from "react";
import { downloadRegistrationAgreement } from "../../infrastructure/repositories/AuthRepository";

const PDF_TOKEN_KEY = "registration_pdf_token";
const PDF_PATH_KEY = "registration_pdf_download_path";
const PDF_EXPIRES_KEY = "registration_pdf_expires_at";
const REQUEST_ID_KEY = "registration_request_id";

export const persistRegistrationAgreementDownload = (params: {
  requestId: string;
  token: string;
  downloadPath: string;
  expiresAt?: string;
}): void => {
  sessionStorage.setItem(REQUEST_ID_KEY, params.requestId);
  sessionStorage.setItem(PDF_TOKEN_KEY, params.token);
  sessionStorage.setItem(PDF_PATH_KEY, params.downloadPath);
  if (params.expiresAt) {
    sessionStorage.setItem(PDF_EXPIRES_KEY, params.expiresAt);
  } else {
    sessionStorage.removeItem(PDF_EXPIRES_KEY);
  }
};

export const useDownloadAgreement = () => {
  const [loading, setLoading] = useState(false);

  const downloadAgreement = async () => {
    const requestId = sessionStorage.getItem(REQUEST_ID_KEY);
    const token = sessionStorage.getItem(PDF_TOKEN_KEY);
    const downloadPath = sessionStorage.getItem(PDF_PATH_KEY);
    const expiresAt = sessionStorage.getItem(PDF_EXPIRES_KEY);

    if (!requestId || !token) {
      throw new Error("Agreement information not found.");
    }

    if (expiresAt) {
      const expiry = Date.parse(expiresAt);
      if (!Number.isNaN(expiry) && expiry < Date.now()) {
        throw new Error(
          "The agreement download link has expired. Please contact support.",
        );
      }
    }

    setLoading(true);

    try {
      const blob = await downloadRegistrationAgreement(
        requestId,
        token,
        downloadPath,
      );

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Registration-Agreement.pdf";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } finally {
      setLoading(false);
    }
  };

  return {
    downloadAgreement,
    loading,
  };
};
